<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          No：{{
            formData.platformNo
              ? formData.platformNo
              : $l('btn_drawer_add') || '新增'
          }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          style="font-size: 12px"
          :variant="
            formData.platformStatus === 'Y'
              ? 'success'
              : formData.platformStatus === 'N'
              ? 'danger'
              : formData.platformStatus === 'S'
              ? 'warning'
              : 'primary'
          "
        >
          {{ formData.v_platformStatus || $l('btn_drawer_add') || '新增' }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Modify：{{ formData.modifyByName ? formData.modifyByName : '--' }} at
          {{ formData.modifyDate ? formData.modifyDate : '--' }}
        </span>
      </div>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="small"
    >
      <el-row :gutter="10" class="mb-2">
        <el-col :span="24">
          <span style="font-size: 14px;color: #101010;font-weight: bold;">
            {{ $l('form_label_business_information') || '业务信息' }}
          </span>
        </el-col>
        <el-col :span="24">
          <span style="font-size: 12px;color: #6C757D;">
            {{
              $l('form_label_channel_related_business') ||
                '渠道相关业务信息，由业务人员填写'
            }}
          </span>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_platformName') || '渠道名称'"
            prop="platformName"
          >
            <el-input
              v-model="formData.platformName"
              clearable
              size="small"
              :placeholder="$l('please_label_platformName') || '请输入渠道名称'"
              maxlength="50"
              @change="valueChange"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_regionName') || '所属地区'"
            prop="regionCode"
          >
            <dict-select
              filterable
              size="small"
              clearable
              v-model="formData.regionCode"
              :selectedLabel.sync="formData.regionName"
              :body="regionParams"
              url="/master/common/dict/biz"
              :placeholder="
                $l('please_label_regionName') || '请选择所属国家地区'
              "
              @change="valueChange"
            ></dict-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_platformType') || '渠道类型'"
            prop="platformType"
          >
            <dict-select
              filterable
              size="small"
              clearable
              v-model="formData.platformType"
              :body="platformTypeParams"
              url="/sys/common/dict/system"
              :placeholder="$l('please_label_platformType') || '请选择渠道类型'"
              @change="valueChange"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_CompanyName') || '申请公司'"
            prop="ecomCompanyCode"
          >
            <dict-select
              size="small"
              clearable
              filterable
              v-model="formData.ecomCompanyCode"
              url="/ecom/ecomCompany/select"
              @change="valueChange"
              :placeholder="$l('please_label_ecomCompany') || '请选择申请公司'"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_custCode') || '所属客户'"
            prop="custCode"
          >
            <dict-select
              v-model="formData.custCode"
              url="/master/common/dict/customerSelect"
              :placeholder="$l('please_label_cust') || '请选择所属客户...'"
              size="small"
              clearable
              filterable
              @change="valueChange"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item :label="$l('form_label_remark') || '备注说明'">
            <el-input
              type="textarea"
              v-model="formData.remark"
              clearable
              size="small"
              :placeholder="$l('please_label_remark') || '请输入备注说明'"
              rows="3"
              maxlength="1000"
              @change="valueChange"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="mb-2 mt-2">
        <el-col :span="24">
          <span style="font-size: 14px;color: #101010;font-weight: bold;">
            {{ $l('form_label_technical_information') || '技术信息' }}
          </span>
        </el-col>
        <el-col :span="24">
          <span style="font-size: 12px;color: #6C757D;">
            {{
              $l('form_label_external_system_data') ||
                '以下是外部系统数据对接所需信息，由软件开发或IT部门填写'
            }}
          </span>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_platformId') || '渠道ID'"
            prop="platformId"
          >
            <el-input
              v-model="formData.platformId"
              clearable
              size="small"
              :placeholder="$l('please_label_platformId') || '请输入渠道ID'"
              maxlength="20"
              @change="valueChange"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_ecomPmaCode') || '对接电商平台'"
            prop="ecomPmaCode"
          >
            <dict-select
              filterable
              size="small"
              clearable
              v-model="formData.ecomPmaCode"
              :body="ecomPmaCodeParams"
              url="/ecom/evg/platform/select/account"
              :placeholder="$l('please_label_ecomPma') || '请选择对接电商平台'"
              @change="valueChange"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_warehousePmaCode') || '仓库平台账户'"
            prop="warehousePmaCode"
          >
            <dict-select
              filterable
              size="small"
              clearable
              v-model="formData.warehousePmaCode"
              :body="warehousePmaCodeParams"
              url="/ecom/evg/platform/select/account"
              :placeholder="
                $l('please_label_warehousePma') || '请选择仓库平台账户'
              "
              @change="valueChange"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_shippingMethod') || '发运方式'"
            prop="shippingMethod"
          >
            <el-input
              v-model="formData.shippingMethod"
              clearable
              size="small"
              :placeholder="
                $l('please_label_shippingMethod') || '请输入发运方式'
              "
              @change="valueChange"
              maxlength="100"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_warehouseCode') || '仓库代码'"
            prop="warehouseCode"
          >
            <el-input
              v-model="formData.warehouseCode"
              clearable
              size="small"
              :placeholder="
                $l('please_label_warehouseCode') || '请输入仓库代码'
              "
              @change="valueChange"
              maxlength="100"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_shipNode') || '分销商ID'"
            prop="shipNode"
          >
            <el-input
              v-model="formData.shipNode"
              clearable
              size="small"
              :placeholder="$l('please_label_shipNode') || '请输入分销商ID'"
              @change="valueChange"
              maxlength="100"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_inventoryBalanceRatio') || '仓库库存占比'"
            prop="inventoryBalanceRatio"
          >
            <el-input-number
              style="width: 100%"
              size="small"
              :min="0"
              :max="100"
              :step="1"
              :placeholder="
                $l('please_label_inventoryBalanceRatio') || '请输入仓库库存占比'
              "
              v-model="formData.inventoryBalanceRatio"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_needAttachForShipment') || '否需要上传附件'"
            prop="needAttachForShipment"
          >
            <el-radio-group
              v-model="formData.needAttachForShipment"
              size="small"
              style="width: 100%"
            >
              <el-radio label="Y">
                {{ $l('radio_needAttachForShipment_Y') || '需要' }}
              </el-radio>
              <el-radio label="N">
                {{ $l('radio_needAttachForShipment_N') || '不需要' }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <Logistics
      :platformCode="platformCode"
      :logisticsAccount="formData.logisticsAccount"
      :disabled="disabled"
      ref="logistics"
    />
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save('save')" type="primary" size="small">
          {{ $l('btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import Logistics from './logistics'
export default {
  mixins: [EditLoading],
  props: {
    platformCode: { type: String, default: '' },
    status: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      regionParams: { dictType: 'region' },
      platformTypeParams: { dictType: 'platformType' },
      ecomPmaCodeParams: { platformType: 'E' },
      warehousePmaCodeParams: { platformType: 'W' },
      formData: {},
      backDialogVisible: false,
      valueChangeFlag: false,
      rules: {
        platformName: [
          {
            required: true,
            message: this.$l('please_label_platformName') || '请输入渠道名称',
            trigger: 'blur',
          },
        ],
        // platformId: [
        //   {
        //     required: true,
        //     message: this.$l('please_label_platformId') || '请输入渠道ID',
        //     trigger: 'blur',
        //   },
        // ],
        regionCode: [
          {
            required: true,
            message: this.$l('please_label_regionName') || '请选择所属国家地区',
            trigger: 'change',
          },
        ],
        ecomCompanyCode: [
          {
            required: true,
            message: this.$l('please_label_ecomCompany') || '请选择申请公司',
            trigger: 'change',
          },
        ],
        platformType: [
          {
            required: true,
            message: this.$l('please_label_platformType') || '请选择渠道类型',
            trigger: 'change',
          },
        ],
        custCode: [
          {
            required: true,
            message: this.$l('please_label_cust') || '请选择所属客户...',
            trigger: 'change',
          },
        ],
      },
    }
  },
  components: { Logistics },
  mounted() {
    this.getData()
  },
  methods: {
    valueChange() {
      this.valueChangeFlag = true
    },
    getData() {
      if (!this.platformCode) return
      this.$api
        .ecomEvgPlatformDetailApi({
          platformCode: this.platformCode,
        })
        .then((res) => {
          this.formData = res.body
          this.$emit('update:status', this.formData.platformStatus)
        })
    },
    async save(saveType) {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)
      this.loadingOpen()

      this.$api
        .ecomEvgPlatformSaveApi({
          ...this.formData,
          saveType,
          logisticsAccount: this.$refs.logistics.getTableData(),
        })
        .then(async (res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('tips_save_ok') || '保存成功！',
            type: 'success',
          })
          this.close()
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('tips_save_no') || '保存失败！')
        })
    },
    cancel() {
      if (!this.valueChangeFlag) return this.close()
      this.backDialogVisible = true
    },
    close() {
      this.valueChangeFlag = false
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
